import { z } from "zod/v4";

export const auditActionSchema = z.enum([
	"created",
	"updated",
	"deleted",
	"status_changed",
	"role_changed",
	"permission_granted",
	"permission_revoked",
	"member_added",
	"member_removed",
	"sent",
]);

export type AuditAction = z.infer<typeof auditActionSchema>;

export const auditEntityTypeSchema = z.enum([
	"invoice",
	"payment",
	"membership_fee",
	"account",
	"booking",
	"expense",
	"fiscal_year",
	"boost",
	"club_member",
	"event",
	"poll",
	"announcement",
	"newsletter",
	"club",
]);

export type AuditEntityType = z.infer<typeof auditEntityTypeSchema>;

export const auditLogEntrySchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	actor_id: z.string().uuid().nullable().optional(),
	actor_name: z.string().nullable().optional(),
	// Lenient: the feed is club-wide and other services may write entity types/actions
	// this enum does not list. Parse them as raw strings so one unknown value can never
	// crash the whole list; the UI falls back to showing the raw key.
	entity_type: z.string(),
	entity_id: z.string().uuid().nullable().optional(),
	action: z.string(),
	field: z.string(),
	old_value: z.unknown().optional(),
	new_value: z.unknown().optional(),
	created_at: z.coerce.date(),
});

export type AuditLogEntry = z.infer<typeof auditLogEntrySchema>;

export const paginatedAuditLogSchema = z.object({
	items: z.array(auditLogEntrySchema),
	total: z.number(),
	limit: z.number(),
	offset: z.number(),
});

export type PaginatedAuditLog = z.infer<typeof paginatedAuditLogSchema>;
